import { Group, Stack, Text, Tooltip } from "@mantine/core";
import { IconConfetti, IconDownload } from "@tabler/icons-react";

import { WhatsNewUpdate } from "../update";

export const update20240101: WhatsNewUpdate = {
  id: "9F9CBA70-CBE3-452A-A8E7-83A927FEFC34",
  date: "2024-01-01",
  subject: (
    <Group spacing="xs">
      Happy new year!
      <IconConfetti />
    </Group>
  ),
  content: (
    <>
      <Stack>
        <Text>
          Welcome to the changelog for fs-checklist-studio! Today adds PDF export, and improved
          mobile layout, and several performance fixes.
        </Text>
        <Stack spacing={0}>
          <Text>
            Documents can now be exported as PDFs from the editor. Just click the{" "}
            <Tooltip label="Download as PDF">
              <IconDownload size={14} />
            </Tooltip>{" "}
            button in the toolbar above the document name.
          </Text>
        </Stack>
      </Stack>
    </>
  ),
};
